module.exports = __webpack_public_path__ + "images/pages/sns_campaign_lp/mainvisual-bg-sp_40a320a8d422652a9ab98485d9808b89.png";